/**
 * Author: Agent
 * Generation: Frame URL builder utility
 * Version: v3.0.1
 * Modified: 2025-11-07
 * One-liner: Build frame URLs from base + pattern
 */

/**
 * Build frame URLs from base path and pattern
 * - pattern supports `{i}` token (will be zero-padded by pad)
 * - pattern `*` appends raw index (no extension handling)
 * - when pattern lacks token, fallback to `${i}.ext` guessing from pattern ext
 */
export function buildFrameUrls(base: string, pattern: string, frameCount: number, pad: number = 0): string[] {
  const out: string[] = [];
  const join = (a: string, b: string) => (a.endsWith('/') ? a.slice(0, -1) : a) + '/' + (b.startsWith('/') ? b.slice(1) : b);

  for (let i = 0; i < frameCount; i++) {
    let url: string;
    if (pattern === '*') {
      url = join(base, String(i));
    } else if (pattern.includes('{i}')) {
      const s = pad > 0 ? String(i).padStart(pad, '0') : String(i);
      url = join(base, pattern.replace('{i}', s));
    } else {
      // infer extension
      const ext = pattern.includes('.') ? pattern.split('.').pop() : '';
      const filename = ext ? `${i}.${ext}` : String(i);
      url = join(base, filename);
    }
    out.push(url);
  }
  return out;
}

